import moment from 'moment'
import { ForwardedRef, forwardRef, useState } from 'react'

import { useInterval } from '../../hooks'
import { PIXELS_PER_MINUTE } from '../../utils/calendar'

export const CalendarCurrentTimeLine = forwardRef((_, ref: ForwardedRef<HTMLDivElement | null>) => {
    const [timeLineOffset, setTimeLineOffset] = useState(moment().hour() * 60 + moment().minute())

    useInterval(() => setTimeLineOffset(moment().hour() * 60 + moment().minute()), 1000)

    return (
        <div
            className="text-danger-400 absolute left-[95px] mt-[-3px] flex w-[calc(100%-95px)]"
            style={{ top: timeLineOffset * PIXELS_PER_MINUTE }}
            ref={ref}
        >
            <div className="border-danger-400 h-[5px] w-[5px] rounded-full border-[1px] bg-white"></div>
            <div className="border-t-danger-400 mt-[2px] flex-1 border-t-[1px]"></div>
        </div>
    )
})
